module.exports = __webpack_public_path__ + "img/PPT.d55b1a0e.png";